/**
 * Links para a Pesquisa de Mercado oficial do LatamRO.
 *
 * Mesma abordagem já usada no site principal (web/src/lib/crafting/market.ts):
 * mandamos o jogador para a busca oficial já preenchida, que tem preço em tempo
 * real e histórico por item. Espelhar esses dados aqui custaria banda nossa e
 * não entregaria nada que a página oficial não entregue melhor — e a origem não
 * manda CORS, então nada disso rodaria no navegador de qualquer forma.
 */

export const MARKET_SERVERS = ['FREYA', 'NIDHOGG'];

export const MARKET_SERVER_LABEL = {
  FREYA: 'Freya',
  NIDHOGG: 'Nidhogg',
};

// The site moved from ro.gnjoylatam.com (which still 301s here, query intact).
const BASE = 'https://ro.gnjoyamericas.com/pt/intro/shop-search/trading';

/**
 * Acento a busca oficial aceita numa boa ("Poção Vermelha" responde certo). O
 * que derruba a página é pontuação: `- [ ] ( ) & + /` quebram a busca.
 *
 * Então o termo é o nome inteiro e, só quando existe pontuação, ele vira o
 * maior pedaço entre elas. Esse pedaço continua sendo trecho literal do nome
 * real, então casa na busca por substring: "Sopra-Poporing de Sabão" procura
 * por "Poporing de Sabão" e acha o item.
 */
export function marketSearchTerm(itemName) {
  const runs = String(itemName || '').match(/[\p{L}\p{N}]+(?: [\p{L}\p{N}]+)*/gu);
  if (!runs || !runs.length) return itemName || '';
  return runs.reduce((a, b) => (b.length > a.length ? b : a));
}

/** URL da busca oficial de barracas para um item, já filtrada por servidor. */
export function marketSearchUrl(itemName, server) {
  const q = new URLSearchParams({
    storeType: 'BUY',
    serverType: server,
    searchWord: marketSearchTerm(itemName),
    sortType: 'LOW_PRICE',
  });
  return `${BASE}?${q.toString()}`;
}
